import { Spinner } from "@fluentui/react-components";
import { format } from "date-fns";
import React, { useEffect } from "react";
import { FlightListContext } from "../../../../../../context/FlightListContext";
import { LayoutContext } from "../../../../../../context/LayoutContext";
import { FlightLegTypeEnum } from "../../../../../../enum/FlightsEnum";
import { useApiCall } from "../../../../../../hooks/useApiCall";
import { IFlightTabsListCard } from "../../../../../../models/flights/IFlightListCard";
import { useAppSelector } from "../../../../../../store/StoreHooks";
import { getAirportCode } from "../../../../../../store/airport/AirportSelector";
import { NoDataCard } from "../../../../../common/no-data-card/NoDataCard";
import { FlightListCard } from "./FlightListCard";

interface IFlightListTabContent {
  type: FlightLegTypeEnum;
  setTabLoading: (prev: boolean) => void;
}

const FlightListTabContent: React.FC<IFlightListTabContent> = ({
  type,
  setTabLoading,
}) => {
  let filteredData;
  const { timezone, globalFilterDate } = React.useContext(LayoutContext);

  const ariaLabelledBy =
    type === FlightLegTypeEnum.Arrival
      ? "Arrivals"
      : type === FlightLegTypeEnum.Departure
      ? "Departures"
      : "All Arrivals & Departures";

  const { selectedOptions, updateFlightList } =
    React.useContext(FlightListContext);
  const airportCode = useAppSelector((state) => getAirportCode(state));

  const getFlightTabsUrl = `${process.env.REACT_APP_API_FLIGHTTABSLIST?.replace(
    "{airportCode}",
    airportCode
  )}`;

  const legType = type === "all" ? null : type;

  const payload = {
    start: format(globalFilterDate.startDate, "yyyy-MM-dd'T'HH:mm:ss"),
    end: format(globalFilterDate.endDate, "yyyy-MM-dd'T'HH:mm:ss"),
    legType,
    tz: timezone,
  };

  const {
    data: flightListdata,
    error,
    isLoading,
  } = useApiCall<IFlightTabsListCard[]>({
    url: getFlightTabsUrl,
    dependencies: [airportCode, timezone],
    payload,
    requestType: "post",
  });

  filteredData = flightListdata;

  useEffect(() => {
    setTabLoading(isLoading);
  }, [isLoading]);

  useEffect(() => {
    updateFlightList(flightListdata ?? []);
  }, [flightListdata]);

  // Further filter the data based on selectedOptions
  if (selectedOptions.length > 0) {
    filteredData = flightListdata?.filter(
      // Replace someProperty with the actual property you want to filter by
      (flight) => selectedOptions.includes(flight.flightNumber)
    );
  }

  if (isLoading) {
    return (
      <Spinner
        labelPosition="below"
        label="Loading..."
        style={{ height: "35vh" }}
      />
    );
  }

  if (error) {
    return <NoDataCard message="No Flight data found" />;
  }

  return (
    <div role="tabpanel" aria-labelledby={ariaLabelledBy}>
      {filteredData && filteredData?.length > 0 ? (
        filteredData.map((flight) => (
          <FlightListCard key={flight.id} {...flight} />
        ))
      ) : (
        <NoDataCard message="No Flight data found" />
      )}
    </div>
  );
};

export default FlightListTabContent;
